<template>
   <div class="player-double-speed">
      <button tabindex="0" type="button" class="btn btn-link left-square" @click="$emit('seekBackward')">
        <svg t="1612233834299" class="icon" fill="currentColor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10176" width="200" height="200"><path d="M339.968 195.584l-141.824-45.056L229.888 5.12l33.792 58.88C337.408 23.04 421.888 0 512 0c282.624 0 512 229.376 512 512s-229.376 512-512 512S0 794.624 0 512c0-46.08 6.144-90.624 17.408-133.12l77.312 20.48c-9.728 35.84-14.848 73.728-14.848 112.64 0 238.592 193.536 432.128 432.128 432.128s432.128-193.536 432.128-432.128-193.536-432.128-432.128-432.128c-75.264 0-146.432 19.456-207.872 53.248l35.84 62.464z" p-id="10177"></path><path d="M418.304 330.24v356.864H364.032v-291.84c-22.016 20.48-49.152 35.84-81.92 45.056V386.56c15.872-4.096 32.768-10.752 51.2-20.992 17.92-11.264 32.768-23.04 44.032-35.328h40.96zM512 330.24h215.04v48.128h-171.008L545.28 481.28h1.536c10.752-11.264 23.552-19.456 37.888-24.576 12.8-5.12 27.136-8.192 44.032-8.192 33.792 0 60.928 10.752 81.92 32.768 21.504 22.528 31.744 52.736 31.744 90.624 0 36.864-13.824 67.072-40.96 90.624-25.088 20.992-55.808 31.744-91.648 31.744-31.744 0-59.392-8.704-82.432-26.624-25.088-18.944-39.424-45.056-41.984-78.336h53.248c2.048 20.48 9.728 35.328 23.552 45.568 11.776 9.216 28.16 13.312 48.128 13.312 21.504 0 39.936-6.656 55.296-20.48 14.848-13.824 22.528-32.256 22.528-54.784 0-25.088-6.656-44.544-19.456-58.368s-31.232-20.992-54.784-20.992c-16.384 0-30.208 3.072-41.472 8.704-12.8 5.632-22.528 15.36-29.696 28.672H491.52l20.48-200.704z" p-id="10178"></path></svg>
      </button>
      <button tabindex="0" v-if="episode.enableSpeed" @click="changeRate" type="button" class="btn btn-link double-speed">{{ rateTexts[rateIndex] }}</button>
      <button tabindex="0" type="button" class="btn btn-link right-square" @click="$emit('seekForward')">
        <svg t="1612232411279" class="icon" fill="currentColor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10145" width="200" height="200"><path d="M719.953 133.253C658.263 99.31 587.386 80 512 80 273.413 80 80 273.413 80 512s193.413 432 432 432 432-193.413 432-432c0-38.94-5.152-76.676-14.812-112.565l77.395-20.335C1017.943 421.482 1024 466.034 1024 512c0 282.77-229.23 512-512 512S0 794.77 0 512 229.23 0 512 0c89.96 0 174.502 23.201 247.967 63.946L794 5l31.603 145.263L684 195.526l35.953-62.273zM418.5 330v357H364V395.5c-22 20.667-49.333 35.667-82 45v-54c16-4 33-11 51-21 18-11.333 32.667-23.167 44-35.5h41.5z m93.333 0h215v48h-171l-10.5 103h1.5c11-11.333 23.667-19.5 38-24.5 12.667-5.333 27.334-8 44-8 33.667 0 61 11 82 33 21.334 22.333 32 52.5 32 90.5 0 36.667-13.666 66.833-41 90.5-25.333 21-55.833 31.5-91.5 31.5-31.666 0-59.166-8.833-82.5-26.5-25.333-19-39.333-45.167-42-78.5h53.5c2 20.333 9.834 35.5 23.5 45.5 12 9 28 13.5 48 13.5 21.667 0 40.167-6.833 55.5-20.5 15-14 22.5-32.333 22.5-55 0-25-6.5-44.5-19.5-58.5s-31.333-21-55-21c-16.333 0-30.166 2.833-41.5 8.5-12.666 5.667-22.5 15.167-29.5 28.5h-51l19.5-200z" p-id="10146"></path></svg>
      </button>
    </div>
</template>

<script>
    import { MUTATION_UPDATE } from "@/store/mutations";
    import { mapGetters } from "vuex";

    export default {
      name: "PlayerToolbar",
      data() {
        return {
          rateIndex: this.$store.state.playbackRateIndex,
          rates:[0.8, 1, 1.2, 1.5, 2],
          rateTexts:['0.8', '1x', '1.2', '1.5', '2x'],
        };
      },
      computed:{
        ...mapGetters(['episode']),
      },
      methods: {
        changeRate() {
          if (this.rateIndex + 1 >= this.rates.length){
            this.rateIndex = 0;
          }else{
            this.rateIndex ++;
          }

          this.$store.commit(MUTATION_UPDATE,['playbackRate',this.rates[this.rateIndex]]);
          this.$store.commit(MUTATION_UPDATE,['playbackRateIndex',this.rateIndex]);

        }
      }
    }
</script>

<style scoped lang="scss">
.player-double-speed{
  position: absolute;
  left: 50%;
  top: 21%;
  transform: translate(-50%,-50%);
  margin: 0 auto;
  text-align: center;
  max-width: 100px;
  display: none;
  margin-left: 25px;
  button{
    border: none;
    padding: 2px 3px;
    line-height: 1;
    background: transparent;
    &:hover,&:focus{
      /*opacity: 0.75;*/
      svg{
        path{
          //fill: #d1d1d1;
          opacity: 0.8;
        }
      }
    }
    svg{
      width: 18px;
      height: 18px;
      //color: #888888;
    }
  }
  .left-square,.right-square{
    padding: 2px 6px;
  }
  .double-speed{
    font-size: 14px;
    //color: #959595;
    padding: 0;
    &:hover,&:focus{
      opacity: 0.75;
    }
  }
}

@media (max-width: 425px) {
  .player-double-speed{
     display: none !important;
  }


}

</style>
